var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTally3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C18.75 32 8 42.75 8 56V456C8 469.25 18.75 480 32 480S56 469.25 56 456V56C56 42.75 45.25 32 32 32ZM160 32C146.75 32 136 42.75 136 56V456C136 469.25 146.75 480 160 480S184 469.25 184 456V56C184 42.75 173.25 32 160 32ZM288 32C274.75 32 264 42.75 264 56V456C264 469.25 274.75 480 288 480S312 469.25 312 456V56C312 42.75 301.25 32 288 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTally3);
export default __webpack_public_path__ + "static/media/tally-3.956bbff91614c9a3ec791c5f9e51219c.svg";
export { ForwardRef as ReactComponent };